!(function ($) {
  $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault()

    $('html, body').animate(
      {
        scrollTop: $($.attr(this, 'href')).offset().top,
      },
      500
    )
  })
  function wrapAll(parent, elem) {
    if (parent.length > 0 && elem.length) {
      elem.each(function (i, el) {
        $(el).next('p').addBack().wrapAll('<div class="item_inner" />')
      })
      setTimeout(function () {
        $('.faq_wrap .inner .item_inner').wrap('<div class="item" />')
      }, 0)
    }
  }
  wrapAll($('.faq_wrap'), $('.faq_wrap .inner h2'))
  wrapAll($('.faq_wrap'), $('.faq_wrap .inner h3'))
  wrapAll($('.faq_wrap'), $('.faq_wrap .inner h4'))
  wrapAll($('.faq_wrap'), $('.faq_wrap .inner h5'))
  wrapAll($('.faq_wrap'), $('.faq_wrap .inner h6'))

  document.addEventListener('DOMContentLoaded', () => {
    window.onscroll = function (e) {
      if ($('body.template--product').length) {
        if (
          $('.sticky-cart-wrapper.atcbar.custom').hasClass('hidden') == true
        ) {
          /*$(".needsclick[aria-label=\"Open Form\"]").css({
                        "bottom": "0"
                    });*/
          $('html body #gladlyChat_container').css({
            bottom: '0',
          })
        } else {
          /*$(".needsclick[aria-label=\"Open Form\"]").css({
                        "bottom": $(".sticky-cart-wrapper.atcbar.custom").outerHeight() + 'px'
                    });*/
          $('html body #gladlyChat_container').css(
            'bottom',
            $('.sticky-cart-wrapper.atcbar.custom').outerHeight() + 'px'
          )
        }
      }
    }
  })

  $('.product_tab').each(function (i, elem) {
    $(elem).on('click', function (e) {
      e.preventDefault()
      $('.product_tab').removeClass('opened')
      $(this).addClass('opened')

      $('.product_tab__content[data-ind]').removeClass('opened')
      $(
        '.product_tab__content[data-ind=' + $(this).attr('data-ind') + ']'
      ).addClass('opened')
    })
  })
  $(window).on('load', function () {
    setTimeout(function () {
      var iframe = document.getElementById('launcher')
      var elmnt =
        iframe.contentWindow.document.getElementsByTagName('button')[0]
      //elmnt.style.backgroundColor = "green";
      //console.log("iframe setTimeout test");
      //console.log(iframe);

      $(document).on('click', 'li.live_chat .item_data', function (e) {
        var iframe = document.getElementById('launcher')
        var elmnt =
          iframe.contentWindow.document.getElementsByTagName('button')[0]
        //$("#gladlyChatDragHandle").trigger("click")
        //elmnt.style.backgroundColor = "blue";
        elmnt.click()
        //elmnt.classList.add('dsadasdasdsadsadsadasdsadsadsad');
        //elmnt.querySelector('[aria-hidden]').click();
        iframe.contentWindow.document
          .getElementsByTagName('button > div')
          .click()
      })
    }, 3000)

    let _fl = true
    setTimeout(function () {
      $('#launcher').parent('div').addClass('parent_launcher')
    }, 1000)

    jQuery(window).on('scroll', function () {
      if (_fl) {
        setTimeout(function () {
          $('#launcher').parent('div').addClass('parent_launcher')
          _fl = false
        }, 1000)
      }
    })

    if ($('body.temp--reviews').length >= 1) {
      $('body.temp--reviews .stamped-pagination').before(
        "<a href='#MainContent' class='anchor_top'>back to top</a>"
      )
    }
  })
})(jQuery)
